import { render, staticRenderFns } from "./ZxcgcsView.vue?vue&type=template&id=35c11da7&scoped=true"
import script from "./ZxcgcsView.vue?vue&type=script&lang=js"
export * from "./ZxcgcsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c11da7",
  null
  
)

export default component.exports